/// <reference types="vite/client" />

/**
 * Read a Vite environment variable. Throws in production if the value is missing.
 * In development, returns an empty string for missing values (fail-soft for DX).
 */
export function getRequiredEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value && import.meta.env.PROD) {
    throw new Error(`Missing required environment variable: '${key}'`);
  }
  return value ?? '';
}

/**
 * Read a Vite environment variable without ever throwing.
 * Returns the value when set, or an empty string when absent or empty.
 *
 * Use for optional variables whose absence is a documented, valid state.
 * Example: VITE_APPINSIGHTS_CONNECTION_STRING — an empty value means
 * telemetry is intentionally disabled (no throw, no console noise in local dev).
 */
export function getOptionalEnv(key: string): string {
  return import.meta.env[key] ?? '';
}
